// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"11":"membercard","95":"handle-transfer","443":"about","571":"settings","584":"block","805":"transactions","809":"transfer"}[chunkId] + "." + {"11":"7cec3e07","95":"7a5816f7","443":"319287d2","571":"57e2f40b","584":"ffbd64d6","805":"fc173553","809":"ddd33a9a"}[chunkId] + ".js";
};